import { render, staticRenderFns } from "./R1.vue?vue&type=template&id=74f53493&scoped=true&"
import script from "./R1.vue?vue&type=script&lang=js&"
export * from "./R1.vue?vue&type=script&lang=js&"
import style0 from "./R1.vue?vue&type=style&index=0&id=74f53493&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f53493",
  null
  
)

export default component.exports